"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Classes = void 0;
var Classes;
(function (Classes) {
    Classes["onDark"] = "on-dark";
    Classes["disabled"] = "disabled";
})(Classes = exports.Classes || (exports.Classes = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/BaseCta/BaseCtaProps.js
// module id = 597
// module chunks = 8